var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { NavVertical } from '../Sidebar/index.js';
import { useTrayContext } from './TrayContext.js';
export const TrayActionList = (_a) => {
    var { children, className } = _a, rest = __rest(_a, ["children", "className"]);
    return (React.createElement(NavVertical, Object.assign({ size: "lg", className: className }, rest),
        React.createElement(NavVertical.Group, null, children)));
};
export const TrayActionListItem = ({ children, onClick, leadingIcon, trailingIcon, active, className, }) => {
    const { onClose } = useTrayContext();
    return (React.createElement(NavVertical.Item, { onClick: () => {
            onClose();
            setTimeout(() => {
                onClick === null || onClick === void 0 ? void 0 : onClick();
            }, 500);
        }, leadingIcon: leadingIcon, trailingIcon: trailingIcon, active: active, className: className }, children));
};
//# sourceMappingURL=TrayActionList.js.map